import { createContext, RefObject } from 'react';

import { Defaultize } from '../../types';
import { BraxToast, BraxToastProps } from '../BraxToast';

export type CreateToastProps = Defaultize<BraxToastProps, typeof BraxToast.defaultProps>;

const ToastsContext = createContext<{
    left: RefObject<HTMLElement>,
    right: RefObject<HTMLElement>,
    create: (toast: CreateToastProps) => () => void
}>({
    left: { current: null },
    right: { current: null },
    create: () => () => {}
});

ToastsContext.displayName = 'ToastsContext';

export default ToastsContext;
